(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/game-limits-deposits-form/assets/react/deposit-limit-dropdown.js') >= 0) return;  svs.modules.push('/components/accountservices-react/game-limits-deposits-form/assets/react/deposit-limit-dropdown.js');
'use strict';

const {
  DropdownSelectItem,
  DropdownItem,
  DropdownLabel
} = svs.ui.ReactDropdown;
const {
  useState
} = React;
const Icon = svs.ui.ReactIcon;
const DepositLimitDropdown = _ref => {
  let {
    costOfGame,
    hasErrorRequired,
    errorMessageRequired,
    maxValue,
    minValue,
    onSelect,
    period
  } = _ref;
  const [value, setValue] = useState(period);
  let standardLimits;
  if (maxValue <= 1000) {
    standardLimits = [200, 300, 400, 500, 600, 700, 800, 900, 1000];
  } else if (period === 'Månadsgräns') {
    standardLimits = [200, 500, 1000, 1500, 2000, 2500, 3000];
  } else {
    standardLimits = [200, 300, 400, 500, 600, 800, 1000, 1500, 2000, 2500, 3000];
  }
  const roundedUpCostOfGame = Math.ceil(costOfGame / 100) * 100; 
  const minimumValue = Math.max(roundedUpCostOfGame, minValue || 200) || minValue || 200; 
  const baseArrayKeys = [-1, 1]; 
  const limits = baseArrayKeys.concat(standardLimits.filter(standardLimit => standardLimit <= maxValue && standardLimit > minimumValue));
  if (maxValue < 3000 && !limits.includes(maxValue)) {
    limits.push(maxValue);
  }
  if (!limits.includes(minimumValue)) {
    limits.splice(2, 0, minimumValue);
  }
  let limitTypeIcon;
  let ownLimitText;
  switch (period) {
    case 'Månadsgräns':
      limitTypeIcon = 'calendar-month';
      ownLimitText = 'Välj insättningsgräns per månad';
      break;
    case 'Veckogräns':
      limitTypeIcon = 'calendar-week';
      ownLimitText = 'Välj insättningsgräns per vecka';
      break;
    case 'Dagsgräns':
      limitTypeIcon = 'calendar-day';
      ownLimitText = 'Välj insättningsgräns per dag';
      break;
    default:
      break;
  }
  const dropDownItems = limits.map(limit => {
    if (limit === -1) {
      return React.createElement(DropdownItem, {
        disabled: true,
        key: -1,
        name: period,
        selected: value === period
      }, React.createElement(Icon, {
        icon: limitTypeIcon
      }), React.createElement(DropdownLabel, null, ownLimitText));
    }
    if (limit === 1) {
      return React.createElement(DropdownItem, {
        key: 1,
        name: "own-amount",
        selected: value === 'own-amount'
      }, React.createElement(Icon, {
        color: value === 'own-amount' ? 'fc-green' : '',
        icon: value === 'own-amount' ? limitTypeIcon : 'filter'
      }), React.createElement(DropdownLabel, null, "Skriv eget belopp"));
    }
    return React.createElement(DropdownItem, {
      key: limit,
      name: limit,
      selected: parseInt(value, 10) === limit
    }, React.createElement(DropdownLabel, null, limit, ' kr'));
  });
  const handleOnSelect = name => {
    setValue(name);
    onSelect(name);
  };
  return React.createElement("div", {
    "aria-invalid": hasErrorRequired
  }, React.createElement(DropdownSelectItem, {
    branding: "default",
    defaultText: period,
    onSelect: handleOnSelect,
    selectLabel: value === period ? '' : period,
    v2: true
  }, dropDownItems), hasErrorRequired && React.createElement("div", {
    className: "u-flex dropdown-error"
  }, React.createElement(Icon, {
    color: "fc-red",
    icon: "exclamation-sign",
    size: "200"
  }), React.createElement("p", {
    "aria-live": "assertive",
    className: "margin-bottom-0 f-200"
  }, errorMessageRequired)));
};
svs.accountservicesReact.gameLimitDepositsForm.DepositLimitDropdown = DepositLimitDropdown;

 })(window);